import TransferWorkspace from '../features/transfers/layouts/workspace';

// TSS vite/01 §"Pages are thin". Workspace full-screen de transferencia (pestaña
// propia), abierto desde la acción "Transferencia" de una sesión OPU. Gated en app.jsx.
export default function TransferSessionPage() {
    return <TransferWorkspace />;
}
